export default [
  {
    name: 'discount',
    type: 'float-field',
    flex: {
      xs12: true,
    },
    props: {
      label: 'Descuento',
    },
  },
]